import script from "./cardT.vue?vue&type=script&setup=true&lang=js"
export * from "./cardT.vue?vue&type=script&setup=true&lang=js"

import "./cardT.vue?vue&type=style&index=0&id=1a5dc7b3&lang=css"

const __exports__ = script;

export default __exports__